import './GPCAdditionalNotifications.scss';

import { bool, func } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Content from 'services/Content';
import { isDesktopLayout } from 'state/view/ViewSelectors';
import {
  getCheckboxName,
  getSubscribed,
  optOutAll,
  subOptOutElections
} from 'components/shared/GroupedAccountList/util';
import {
  getHasOwnedCollegeSavingsOnly,
  hasOwnedAlaska529,
  hasOwnedMaryland529,
  hasOwnedNational529
} from 'state/account/AccountSelectors';
import { getHasInvalidOrNoEmailAddress } from 'state/contactMethodMaintenance/ContactMethodMaintenanceSelectors';
import { getFormattedOptoutElections } from 'state/subscriptions/SubscriptionsSelectors';
import { AAMBeaconControlGroup, AAMBeaconControl } from 'components/shared/Beacon';
import { ReactComponent as QuestionCircle } from 'assets/icons/question-circle.svg';
import DisclosureModal from 'components/shared/DisclosureModal/DisclosureModal';
import GPCSubscriptionsRowLabel from 'components/layouts/Preferences/Subscriptions/shared/GPCSubscriptionsRowLabel';

const GPCAdditionalNotifications = ({
  optStatus,
  hasInvalidOrMissingEmail,
  formattedOptOutElections,
  isOwnedMaryland529,
  isOwnedAlaska529,
  isOwnedNational529,
  hasOwnedCollegeSavingsOnly
}) => {

  const getModalContent = (categoryName) => {
   
    if (getCheckboxName(categoryName) === 'Education & Insights') {
      return Content.subscriptionsEducationInsights;
    }
    if (getCheckboxName(categoryName) === 'Products & Services') {
      if(categoryName==="II - Products & Services"){
        return Content.subscriptionsProductsServicesNon529Only;
      }else{
        return Content.subscriptionsProductsServices;
      }
    }
    if (getCheckboxName(categoryName) === 'Research & Surveys') {
      return Content.subscriptionsResearchSurveys;
    }
    return null;
  };

  const handleCheckboxClick = (event) => {
    if(event && event.target) {
      optStatus(event.target.id, event.target.checked);
    }
  };

  return (
    <div className="GPC-additional-notifications-container">
      <div className="GPC-additional-notifications-header-content">Additional Notifications</div>
      <div className="GPC-additional-subscription-row">
        <GPCSubscriptionsRowLabel
        label="Subscribed"
        labelClassname="GPC-subscription-row-header-subscribed" />
      </div>
      <div className="GPC-additional-notifications">
        {getSubscribed({
          hasOwnedCollegeSavingsOnly,
          isOwnedMaryland529,
          isOwnedAlaska529,
          isOwnedNational529
        }).map((item, i) =>
          <div className="GPC-additional-notifications-group-container beacon-on-light"
               key={item.title + i}>
            <AAMBeaconControlGroup>
              <div slot="label">{item.title}</div>
            {subOptOutElections(
              formattedOptOutElections,
              item.title
            ).map((election, ei) =>
                <AAMBeaconControl inline
                                  key={'election'+ei}>
                  <div slot="label" className="additional-notifications-checkbox-label">
                    <label htmlFor={election.categoryName}>
                      {getCheckboxName(election.categoryName)}
                    </label>
                      <DisclosureModal icon={<QuestionCircle slot={'suffix'} />}
                                       closeOnClickOut>
                        <Fragment>
                          <div className="b-typography-serif--headline--200">{getCheckboxName(election.categoryName)}</div>
                          <div className="b-typography-sans-serif--body--200 b-font-weight-light">{getModalContent(election.categoryName)}</div>
                        </Fragment>
                      </DisclosureModal>
                  </div>
                  <input type="checkbox"
                         onChange={handleCheckboxClick}
                         checked={!hasInvalidOrMissingEmail && !election.optOut}
                         id={election.categoryName} />
                </AAMBeaconControl>

            )}
              <AAMBeaconControl inline>
                <label htmlFor={'optOutAll' + item.title}
                       className="additional-notifications-checkbox-label"
                       slot="label">
                  Opt Out of All Notifications
                </label>
                <input type="checkbox"
                       id={'optOutAll' + item.title}
                       checked={
                         !hasInvalidOrMissingEmail &&
                         optOutAll(
                           subOptOutElections(
                             formattedOptOutElections,
                             item.title
                           )
                         )
                       }
                       onChange={handleCheckboxClick}
                />
              </AAMBeaconControl>
            </AAMBeaconControlGroup>
          </div>
        )}
      </div>
      <div className="GPC-additional-notifications-footer">
        {Content.subscriptionsAdditionalNotificationsFooter}
      </div>

    </div>
  );
};

GPCAdditionalNotifications.propTypes = {
  isDesktopLayout: bool.isRequired,
  optStatus: func.isRequired,
  hasInvalidOrMissingEmail: bool.isRequired,
  isOwnedMaryland529: bool.isRequired,
  isOwnedNational529: bool.isRequired,
  isOwnedAlaska529: bool.isRequired,
  hasOwnedCollegeSavingsOnly: bool.isRequired
};

const mapStateToProps = (state) => ({
  isOwnedMaryland529: hasOwnedMaryland529(state),
  hasOwnedCollegeSavingsOnly: getHasOwnedCollegeSavingsOnly(state),
  isOwnedNational529: hasOwnedNational529(state),
  isOwnedAlaska529: hasOwnedAlaska529(state),
  isDesktopLayout: isDesktopLayout(state),
  hasInvalidOrMissingEmail: getHasInvalidOrNoEmailAddress(state),
  formattedOptOutElections: getFormattedOptoutElections(state)
});

export default connect(mapStateToProps)(GPCAdditionalNotifications);
